export default {"src":"/_next/static/media/order-center-active-icon.ab366369.svg","height":14,"width":14};